import exodus from '@/ui/exodus';
import { useNavigate } from '@/ui/utils/navigation.js';
import Item from './item.js';

function Disconnect() {
  const navigate = useNavigate();

  const handleDisconnectClick = () => {
    exodus.analytics.track({
      event: 'SettingsDisconnect',
    });

    navigate('/');
    exodus.wallet.lock();
  };

  return (
    <Item
      icon="arrow-right-circle"
      label={__STANDALONE_MODE__ ? 'Log out' : 'Disconnect'}
      dataTestId="disconnect-settings-item"
      onClick={handleDisconnectClick}
    />
  );
}

export default Disconnect;
